import { z } from 'zod';
const optionalPage = z.coerce.number().int().min(1).optional();
const USER_LINK_STATUSES = ['all', 'linked', 'unlinked'];
export const listUsersQuerySchema = z.object({
    fuzzy: z.string().optional(),
    linkStatus: z.enum(USER_LINK_STATUSES).optional(),
    page: optionalPage,
    pageSize: optionalPage,
});
export const updateUserPasswordSchema = z.object({
    password: z.string().min(8),
    passwordConfirmation: z.string().min(8),
});
export const updateUserEmailSchema = z.object({
    email: z
        .string()
        .min(1, "L'adresse email est requise.")
        .email('Veuillez saisir une adresse email valide.'),
});
export const linkUserClientSchema = z.object({
    clientId: z.string().min(1),
});
